import { LOG } from '../../../helpers/utils';

const modalHandler = {
  openAndClose: (context) => {
    context.setState(prevState => !prevState.showModal);
  },
  state: { showModal: false },
};

const sendMessageToLoader = (message, params) => window.parent.postMessage({ fn: message, params }, '*');

const loaderDataListener = (fn) => {
  LOG('loaderDataListener', fn);
  return window.addEventListener('message', fn);
};

export {
  modalHandler,
  sendMessageToLoader,
  loaderDataListener
};
